<template>
  <avs-button
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    color="error white--text"
    iconI="mdi-cancel"
    noSpantext
  >
    <template v-slot:name>{{ $t("commons.cancel") }}</template>
  </avs-button>
</template>

<script>
export default {
  name: "CancelButton",
  props: {},
  methods: {}
}
</script>
